import React, { ReactNode } from 'react';

// Material-UI
import { Box, Grid } from '@mui/material';

// Project Imports
import AuthCard from '../AuthCard';
import Logo from '../../assets/images/valital-logo-name.png';
import AuthFooter from '../../components/AuthFooter';

// Assets
import AuthBackground from '../../assets/images/AuthBackground';

// Types
interface AuthWrapperProps {
  children: ReactNode;
}

// AuthWrapper Component
const AuthWrapper: React.FC<AuthWrapperProps> = ({ children }) => (
  <Box sx={{ minHeight: '100vh'}}>
    <AuthBackground />
    <Grid
      container
      direction="column"
      justifyContent="flex-end"
      sx={{
        minHeight: '100vh'
      }}
    >
      <Grid item xs={12} sx={{ ml: 3, mt: 3 }}>
       <img src={Logo} height={40} width={140}/>
      </Grid>
      <Grid item xs={12}>
        <Grid
          item
          xs={12}
          container
          justifyContent="center"
          alignItems="center"
          sx={{ minHeight: { xs: 'calc(100vh - 134px)', md: 'calc(100vh - 112px)' } }}
        >
          <Grid item >
            <AuthCard>{children}</AuthCard>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sx={{ ml: 3, mr:3, mt: 1 }}>
        <AuthFooter />
      </Grid>
    </Grid>
  </Box>
);

export default AuthWrapper;